module.exports = __webpack_public_path__ + "static/media/googlePin15.c1568dec.svg";